export const defaultRequiredFields = [
  {
    "canHaveAlternateForm": true,
    "canHaveAnswer": true,
    "canHaveDisplayHorizontal": true,
    "canHaveOptionCorrect": true,
    "canHaveOptionValue": true,
    "canHavePageBreakBefore": true,
    "canPopulateFromApi": true,
    "dirty": true,
    "element": "TextInput",
    "field_name": "text_input_06108B97-D7AC-42A5-8167-ECB948331A10",
    "id": "7306E1AD-745F-4BEE-829C-71BB380ED61B",
    "label": "First Name ",
    "required": true,
    "text": "Text Input"
  },
  {
    "canHaveAlternateForm": true,
    "canHaveAnswer": true,
    "canHaveDisplayHorizontal": true,
    "canHaveOptionCorrect": true,
    "canHaveOptionValue": true,
    "canHavePageBreakBefore": true,
    "canPopulateFromApi": true,
    "dirty": false,
    "element": "TextInput",
    "field_name": "text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143",
    "id": "99267192-0200-403C-813D-8AF374FE25D0",
    "label": "Last Name ",
    "required": true,
    "text": "Text Input"
  },
  {
    "canHaveAlternateForm": true,
    "canHaveDisplayHorizontal": true,
    "canHaveOptionCorrect": true,
    "canHaveOptionValue": true,
    "canHavePageBreakBefore": true,
    "canPopulateFromApi": true,
    "dateFormat": "MM/dd/yyyy",
    "defaultToday": false,
    "element": "DatePicker",
    "field_name": "date_picker_ADA9781E-794B-47F3-BB10-87CD39F5A342",
    "id": "8A37D6EF-A9C1-4561-A16C-991E40512778",
    "label": "Birth Date",
    "required": true,
    "showTimeInput": false,
    "showTimeSelect": false,
    "showTimeSelectOnly": false,
    "text": "Date",
    "timeFormat": "hh:mm aa"
  }
]